export const formName = 'membership-details-form';

export enum KEMembershipOrganizationDetailsFormFields {
  Organization = 'organization',
  SubscriptionType = 'subscriptionType',
  MembershipPlanId = 'membershipPlanId',
  EffectiveDate = 'effectiveDate',
  ExpirationDate = 'expirationDate',
}
